import React, { useState, useEffect, useRef } from "react";
import './App.css';

function App() {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [typing, setTyping] = useState(false);
  const messagesEndRef = useRef(null);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, typing]);

  const sendMessage = async () => {
    if (!input.trim()) return;

    const userMessage = { role: "user", text: input };
    setMessages(prev => [...prev, userMessage]);
    setInput("");
    setTyping(true);

    try {
      const res = await fetch("https://Nominox.pythonanywhere.com/chat", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ message: input }),
      });

      if (!res.ok) {
        throw new Error(`Server error: ${res.status}`);
      }

      const data = await res.json();
      console.log("✅ API Response:", data);

      if (data.reply) {
        const aiMessage = { role: "ai", text: data.reply };
        setMessages(prev => [...prev, aiMessage]);
      } else {
        const errorMsg = { role: "ai", text: "⚠️ Unexpected response from server." };
        setMessages(prev => [...prev, errorMsg]);
      }
    } catch (err) {
      console.error("❌ API Error:", err);
      const errorMsg = { role: "ai", text: "⚠️ Error: Could not reach server. Please try again later." };
      setMessages(prev => [...prev, errorMsg]);
    }

    setTyping(false);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") sendMessage();
  };

  return (
    <div className="app-container">
      <div className="header">
        <h2>
          <span style={{ color: "#10a37f" }}>Sargoo</span>{" "}
          <span style={{ color: "white" }}>GPT</span>
        </h2>
      </div>

      <div className="chat-box">
        {messages.map((m, i) => (
          <div key={i} className={`chat-message ${m.role}`}>
            <div className="chat-bubble">{m.text}</div>
          </div>
        ))}
        {typing && (
          <div className="chat-message ai">
            <div className="chat-bubble">
              <span className="typing-dot"></span>
            </div>
          </div>
        )}
        <div ref={messagesEndRef}></div>
      </div>

      <div className="input-area">
        <input
          value={input}
          onChange={e => setInput(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder="Ask anything"
        />
        <button onClick={sendMessage}>Send</button>
      </div>
    </div>
  );
}

export default App;
